var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "os_choice_block" },
    [
      _c(
        "b-row",
        { staticClass: "doc_title" },
        [
          _c("b-col", { attrs: { sm: "3" } }, [
            _c(
              "label",
              { attrs: { for: _vm.os_field.type + _vm.os_field.id } },
              [_vm._v(_vm._s(_vm.os_field.name) + " ")]
            ),
          ]),
          _vm._v(" "),
          _c("b-col", { attrs: { sm: "6" } }, [
            _c(
              "div",
              { staticClass: "os_block" },
              [
                _c(
                  "v-select",
                  {
                    staticClass: "imc_reasons",
                    attrs: {
                      label: "name",
                      options: _vm.os_search_options,
                      filterable: false,
                    },
                    on: { search: _vm.onSearch, input: _vm.on_select_os },
                    scopedSlots: _vm._u([
                      {
                        key: "option",
                        fn: function (option) {
                          return [
                            _c("div", { staticClass: "d-center" }, [
                              _c("div", [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t" +
                                    _vm._s(option.name) +
                                    " ( " +
                                    _vm._s(option.gosNomer) +
                                    ")\n\t\t\t\t\t\t\t"
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("small", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t\t\t" +
                                      _vm._s(option.zavNomer) +
                                      " - " +
                                      _vm._s(option.invNomer) +
                                      "\n\t\t\t\t\t\t\t\t"
                                  ),
                                ]),
                              ]),
                            ]),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.os_field.insert_val,
                      callback: function ($$v) {
                        _vm.$set(_vm.os_field, "insert_val", $$v)
                      },
                      expression: "os_field.insert_val",
                    },
                  },
                  [
                    _c("template", { slot: "no-options" }, [
                      _vm._v("\n\t\t\t\t\t\tПошук ОС\n\t\t\t\t\t"),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "addon_fields_main" }, [
        _c(
          "div",
          { staticClass: "auction_land_fields" },
          [
            _vm.draw_fields.length > 0
              ? _c("b-container", { attrs: { fluid: "" } }, [
                  _c(
                    "div",
                    { staticClass: "main_info" },
                    _vm._l(this.draw_fields, function (field) {
                      return _c(
                        "b-row",
                        { key: field.id, staticClass: "doc_title" },
                        [
                          _c("b-col", { attrs: { sm: "3" } }, [
                            _c(
                              "label",
                              { attrs: { for: field.type + field.id } },
                              [_vm._v(_vm._s(field.name) + " ")]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { attrs: { sm: "6" } },
                            [
                              field.type == "input"
                                ? _c("b-form-input", {
                                    staticClass: "fs-xl",
                                    attrs: {
                                      type: "text",
                                      readonly: _vm.check_if_locked(field),
                                      state: _vm.is_valid_field(field),
                                      id: field.type + field.id,
                                      size: "sm",
                                    },
                                    model: {
                                      value: field.insert_val,
                                      callback: function ($$v) {
                                        _vm.$set(field, "insert_val", $$v)
                                      },
                                      expression: "field.insert_val",
                                    },
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              field.type == "mech_select"
                                ? _c(
                                    "v-select",
                                    {
                                      staticClass: "imc_reasons",
                                      attrs: {
                                        taggable: "",
                                        "create-option": (book) => ({
                                          label: book,
                                          value: book,
                                        }),
                                        label: "label",
                                        reduce: (item) => item.value,
                                        options: _vm.ekipag_options,
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "option",
                                            fn: function (option) {
                                              return [
                                                _c(
                                                  "div",
                                                  { staticClass: "d-center" },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(option.label) +
                                                        "\n\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                      model: {
                                        value: field.insert_val,
                                        callback: function ($$v) {
                                          _vm.$set(field, "insert_val", $$v)
                                        },
                                        expression: "field.insert_val",
                                      },
                                    },
                                    [
                                      _c("template", { slot: "no-options" }, [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t\tОберіть Механізатора\n\t\t\t\t\t\t\t\t"
                                        ),
                                      ]),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }